import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';

Vue.use(VueRouter);

const files = [
  // barang
  {
    path: '/file/barang',
    name: 'file-barang',
    component: () => import('@/pages/barang/list.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/barang/create',
    name: 'file-file-barang-create',
    component: () => import('@/pages/barang/create.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/barang/update/:id',
    name: 'file-file-barang-update',
    component: () => import('@/pages/barang/update.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },

  // supplier
  {
    path: '/file/supplier',
    name: 'file-supplier',
    component: () => import('@/pages/FileSupplierIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/supplier/create',
    name: 'file-file-supplier-create',
    component: () => import('@/pages/FileSupplierCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/supplier/update/:id',
    name: 'file-file-supplier-update',
    component: () => import('@/pages/FileSupplierUpdate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },

  /** pelanggan */
  {
    path: '/file/pelanggan',
    name: 'file-pelanggan',
    component: () => import('@/pages/FilePelangganIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/pelanggan/create',
    name: 'file-file-pelanggan-create',
    component: () => import('@/pages/FilePelangganCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/pelanggan/update/:id',
    name: 'file-file-pelanggan-update',
    component: () => import('@/pages/FilePelangganUpdate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },

  /** kode-perkiraan */
  {
    path: '/file/kode-perkiraan',
    name: 'file-kode-perkiraan',
    component: () => import('@/pages/FileKodePerkiraanIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/penyesuaian-persediaan',
    name: 'file-penyesuaian-persediaan',
    component: () => import('@/pages/FilePenyesuaianPersediaanIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/penyesuaian-persediaan/create',
    name: 'file-penyesuaian-persediaan-create',
    component: () => import('@/pages/FilePenyesuaianPersediaanCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  /** jenis barang */
  {
    path: '/file/jenis-barang',
    name: 'jenis-barang',
    component: () => import('@/pages/FileJenisBrangIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/jenis-barang/create',
    name: 'jenis-barang-create',
    component: () => import('@/pages/FileJenisBarangCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/jenis-barang/update/:id',
    name: 'jenis-barang-update',
    component: () => import('@/pages/FileJenisBarangUpdate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/settings',
    name: 'settings',
    component: () => import('@/pages/Settings.vue'),
    meta: {
      auth: false,
      layout: 'main',
    },
  },

  {
    path: '/file/users',
    name: 'users',
    component: () => import('@/pages/file/users.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/users/edit/:id',
    name: 'users.edit',
    component: () => import('@/pages/file/user-edit.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/users/new',
    name: 'users.new',
    component: () => import('@/pages/file/user-new.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/roles',
    name: 'roles',
    component: () => import('@/pages/file/roles.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/roles/:id',
    name: 'roles.edit',
    component: () => import('@/pages/file/role-edit.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/file/roles/new',
    name: 'roles.new',
    component: () => import('@/pages/file/role-new.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
];

const reports = [
  {
    path: '/laporan/stock',
    name: 'LaporanStock',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStock.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock-card',
    name: 'LaporanStockCard',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockCard.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock-recap',
    name: 'LaporanStockRecap',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockRecap.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl',
    name: 'LaporanGL',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanGL.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl/subBukuBesar',
    name: 'LaporanSubBukuBesar',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanSubBukuBesar.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl/neracaSaldo',
    name: 'LaporanNeracaSaldo',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanNeracaSaldo.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl/neraca',
    name: 'LaporanNeraca',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanNeraca.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl/rugiLaba',
    name: 'LaporanRugiLaba',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanRugiLaba.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/barang',
    name: 'LaporanStockBarang',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockBarang.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/supplier',
    name: 'LaporanStockSupplier',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockSupplier.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/pelanggan',
    name: 'LaporanStockPelanggan',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockPelanggan.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/pembelian',
    name: 'LaporanStockPembelian',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockPembelian.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/transaksi-pembelian',
    name: 'LaporanStockTrxPembelian',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockTrxPembelian.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/penjualan',
    name: 'LaporanStockPenjualan',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockPenjualan.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/stock/transaksi-penjualan',
    name: 'LaporanStockTrxPenjualan',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanStockTrxPenjualan.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl/kode-perkiraan',
    name: 'LaporanGLKodePerkiraan',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/LaporanGLKodePerkiraan.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/gl/kode-perkiraan-head',
    name: 'LaporanGLKodePerkiraanHead',
    component: () =>
      import(/* webpackChunkName: "store" */ '@/pages/LaporanGLKodePerkiraanHead.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/laporan/hpp',
    name: 'HppReport',
    component: () => import('@/pages/LaporanHpp.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
];

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/Home.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  ...files,
  ...reports,
  // Pembelian
  {
    path: '/pembelian',
    name: 'Pembelian',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PembelianIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/pembelian/create',
    name: 'PembelianCreate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PembelianCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/pembelian/:id',
    name: 'PembelianDetail',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PembelianDetail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/pembelian/:id/update',
    name: 'PembelianDetail',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PembelianUpdate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/penjualan',
    name: 'Penjualan',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PenjualanIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/InvoiceList.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/delivery-notes',
    name: 'DeliveryNotes',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/DeliveryNotes.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/delivery-notes/:id',
    name: 'DeliveryNoteDetail',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/DeliveryNoteDetail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/invoices/:id',
    name: 'InvoiceDetail',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/InvoiceDetail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/penjualan/create',
    name: 'PenjualanCreate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PenjualanCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/penjualan/:id',
    name: 'PenjualanDetail',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PenjualanDetail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/penjualan/:id/update',
    name: 'PenjualanUpdate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/PenjualanUpdate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/transaksiJurnal',
    name: 'TransaksiJurnal',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/TransaksiJurnalIndex.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/kas/create',
    name: 'KasCreate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/KasCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/bank/create',
    name: 'BankCreate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/BankCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/btm/create',
    name: 'BTMCreate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/BTMCreateForm.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/transaksiJurnal/create',
    name: 'TransaksiJurnalCreate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/TransaksiJurnalCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/transaksiJurnal/update/:id',
    name: 'TransaksiJurnalUpdate',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/TransaksiJurnalUpdate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/transaksiJurnal/:id',
    name: 'TransaksiJurnalDetail',
    component: () => import(/* webpackChunkName: "store" */ '@/pages/TransaksiJurnalDetail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },

  {
    path: '/login',
    component: () => import('@/pages/Login.vue'),
    name: 'login',
    meta: {
      auth: false,
      layout: 'auth',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/Register.vue'),
    meta: {
      auth: false,
      layout: 'auth',
    },
  },

  {
    path: '/transactions/incomes/new',
    name: 'transactionsIncomeNew',
    component: () => import('@/pages/IncomeCreate.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/transactions/incomes',
    name: 'transactionsIncomeList',
    component: () => import('@/pages/IncomeList.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/transactions/incomes/:id',
    name: 'transactionsIncomeDetail',
    component: () => import('@/pages/IncomeDetail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/receivables',
    name: 'receivables',
    component: () => import('@/pages/receivables/list.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/receivables/:id',
    name: 'receivables.detail',
    component: () => import('@/pages/receivables/detail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/debts',
    name: 'debts',
    component: () => import('@/pages/debts/list.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/debts/:id',
    name: 'debts.detail',
    component: () => import('@/pages/debts/detail.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/pages/Profile.vue'),
    meta: {
      auth: true,
      layout: 'main',
    },
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  const t = Cookies.get('token');
  if (to.meta.auth) {
    if (t) {
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }
});

export default router;
